// schema
import * as ISchema from "@schema";
// libraries
import React from "react";

// components
import { TeamSections } from "../web-settings";

// util

// material-ui
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Team Name Settings
// ~-~-~-~-~-~-~-
interface TeamPlanDetailsProps {
  org: ISchema.IOrg;
  team: ISchema.ITeam;
}

const useStyles = makeStyles({
  content: {
    marginBottom: 30,
  },
});

export const TeamPlanDetails = (props: TeamPlanDetailsProps) => {
  const classes = useStyles();

  return (
    <div cw-id={`web-settings-${TeamSections.PlanDetails}`} className={classes.content}>
      <Typography variant="h3" className="cw-mb-4">
        Plan details
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-6">
        {props.team.teamName} is currently on the{" "}
        <a href={"https://getclockwise.com"} target="_blank">
          Free
        </a>{" "}
        plan.
      </Typography>
    </div>
  );
};
